import { cn } from '@/shared/utils/cn';
import arrowUpIcon from '@/shared/assets/icons/arrow-up.svg';

const SLIDE_MS = 300;
const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

export interface GoToTopFabProps {
  open: boolean;
  onPress?: () => void;
  className?: string;
  offsetBottomClassName?: string;
  zIndexClassName?: string;
}

/** Dark circle + white arrow; `open` controls slide from bottom. Arrow motion: `.gtf-arrow` in globals.css. */
export function GoToTopFab({
  open,
  onPress,
  className,
  offsetBottomClassName = 'bottom-[var(--go-to-top-mobile-bottom)] md:bottom-24',
  zIndexClassName = 'z-[55]',
}: GoToTopFabProps) {
  const handleClick = () => {
    if (onPress) onPress();
    else if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div
      className={cn(
        'fixed right-4 flex will-change-transform',
        zIndexClassName,
        offsetBottomClassName,
        'motion-reduce:transition-none',
        open ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-16 opacity-0',
        className,
      )}
      style={{ transition: `transform ${SLIDE_MS}ms ${EASE}, opacity ${SLIDE_MS}ms ${EASE}` }}
      aria-hidden={!open}
    >
      <button
        type="button"
        onClick={handleClick}
        className="border-white/10 bg-[#0c2a4a] flex h-12 w-12 shrink-0 items-center justify-center rounded-full border shadow-lg overflow-hidden"
        aria-label="Back to top"
      >
        <img
          src={arrowUpIcon}
          className="gtf-arrow h-full w-5"
          alt=""
          aria-hidden
          style={{ filter: 'brightness(0) invert(1)' }}
        />
      </button>
    </div>
  );
}
